import { RecipientDto } from 'src/store/recipients/recipient';
import { ArrayUtils } from 'src/utils/array';
import { RecipientAction, RecipientTypes } from './recipients.actions';

export type RecipientsState = Readonly<{
  recipients: RecipientDto[];
  errors: any;
}>;

const initialState: RecipientsState = {
  recipients: [],
  errors: null
};

const recipientsReducer = (
  state: RecipientsState = initialState,
  action: RecipientAction
) => {
  switch (action.type) {
    case RecipientTypes.FetchAll:
      return { ...state, recipients: action.recipients };
    case RecipientTypes.Add:
      return {
        ...state,
        recipients: [...state.recipients, action.recipient]
      };
    case RecipientTypes.Update:
      return {
        ...state,
        recipients: ArrayUtils.updateListById(
          state.recipients,
          action.recipient
        )
      };
    case RecipientTypes.Delete:
      return {
        ...state,
        recipient: null,
        recipients: ArrayUtils.deleteFromListById(
          state.recipients,
          action.recipient
        )
      };
    case RecipientTypes.Failure:
      return { ...state, errors: action.errors };
    default:
      return state;
  }
};

export default recipientsReducer;
